import { render, staticRenderFns } from "./NeiBuFile6.vue?vue&type=template&id=67359f07&scoped=true&"
import script from "./NeiBuFile6.vue?vue&type=script&lang=js&"
export * from "./NeiBuFile6.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuFile6.vue?vue&type=style&index=0&id=67359f07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67359f07",
  null
  
)

export default component.exports